import React, { useState, useEffect } from "react";
import FlashCard from "../../components/flashAlerts/FlashCard";
import FlashAlertsFilterBar from "../../components/flashAlerts/FlashAlertsFilterBar";
import ModalLayout from "../../components/layouts/ModalLayout";
import 'react-quill/dist/quill.snow.css';
// import Files from 'react-files'


type Props = {};

const Index = (props: Props) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const date = new Date()
  const [showAddModal, setShowAddModal] = useState<boolean>(false)
  const [title, setTitle] = useState<string>('');
  const [dateField, setDateField] = useState<string>(date.toISOString().split('T')[0]); // default to current date
  const [location, setLocation] = useState<string>('');
  const [images, setImages] = useState<FileList | null>(null);
  const [description, setDescription] = useState<string>('');
  const [addedBy, setAddedBy] = useState<string>('');
  const [flashAlerts, setFlashAlerts] = useState<any[]>([]); // holds all alerts
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Or however many you want per page
  const handleFlashAlertSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("date", dateField);
    formData.append("location", location);
    formData.append("description", description);
    formData.append("added_by", addedBy);

    if (images) {
      for (let i = 0; i < images.length; i++) {
        formData.append("images", images[i]);
      }
    }

    try {
      const response = await fetch(`${BASE_URL}/flash-alerts/upload/`, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        // handle success (e.g., close modal, show success toast)
        setShowAddModal(false);
      } else {
        // handle error (e.g., show error toast)
        console.error("Failed to submit flash alert");
      }
    } catch (error) {
      console.error("Error submitting flash alert:", error);
    }
  };

  useEffect(() => {
    const fetchFlashAlerts = async () => {
      try {
        const response = await fetch(`${BASE_URL}/flash-alerts/`);
        if (!response.ok) throw new Error("Failed to fetch flash alerts");
        const data = await response.json();
        const activeAlerts = data.filter((alert: any) => alert.status === "Active");
        setFlashAlerts(activeAlerts); // Store data in state
      } catch (err) {
        console.error("Error fetching flash alerts:", err);
      }
    };

    fetchFlashAlerts();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = flashAlerts.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(flashAlerts.length / itemsPerPage);

  return (
    <div className="w-full">
      <div className="bg-[#F9FAFB] border border-[#E5E7EB] rounded-xl p-5 mb-6 shadow-sm flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-[#1F2937]">Flash Alerts Feed</h2>
          <p className="mt-1 text-[#4B5563] text-sm">
            View real-time eviction and prevention alerts from across regions
          </p>
        </div>

      </div>

      <div className="flex flex-col lg:flex-row w-full gap-6 px-2 items-start">
        <div className="bg-[#F9FAFB] p-4 pt-4 flex-1 grid grid-cols-1 gap-2">
          <div className="flex bg-white justify-between items-center mb-4 max-h-48 rounded-md shadow-sm border border-[#E5E7EB] p-3">
            <FlashAlertsFilterBar />
          </div>

          <div className="flex-1 grid grid-cols-1 gap-2">
            {currentItems.map((alert) => (
              <FlashCard key={alert.id} data={alert} />
            ))}
          </div>
        </div>
        {/* Left column: Flash Alerts */}


        {/* Right column: Sidebar / extra content */}
        <div className="w-full lg:w-1/3 lg:sticky top-20">
          <div className="space-y-5">
            {/* Upcoming or Ongoing Prevention Activities */}

            <div className="bg-[#F9FAFB] border border-[#E5E7EB] rounded-xl p-4">
              <div className="bg-[#E5E7EB] rounded-t-lg px-3 py-2 mb-3">
                <h2 className="text-[#1F2937] font-semibold text-sm">
                  Upcoming Activities
                </h2>
              </div>

              <ul className="space-y-2 text-[#4B5563] text-xs max-h-32 overflow-y-auto pr-2">
                <li className="flex items-start">
                  <span className="mr-2 text-[#9CA3AF]"></span>
                  <div>
                    <p className="font-medium">No upcoming activities yet.</p>
                    <p className="text-[#6B7280]"></p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 text-[#9CA3AF]"></span>
                  <div>
                    <p className="font-medium"></p>
                    <p className="text-[#6B7280]"></p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 text-[#9CA3AF]"></span>
                  <div>
                    <p className="font-medium"></p>
                    <p className="text-[#6B7280]"></p>
                  </div>
                </li>
                <li className="flex items-start">
                  <span className="mr-2 text-[#9CA3AF]"></span>
                  <div>
                    <p className="font-medium"></p>
                    <p className="text-[#6B7280]"></p>
                  </div>
                </li>
              </ul>
            </div>

            {/* Partner / Coordination Info */}
            <div className="bg-[#F9FAFB] border border-[#E5E7EB] rounded-xl p-4">
              <div className="bg-[#E5E7EB] rounded-t-lg px-3 py-2 mb-3">
                <h2 className="text-[#1F2937] font-semibold text-sm">
                  Coordination Updates
                </h2>
              </div>
              <ul className="space-y-2 text-[#4B5563] text-xs max-h-32 overflow-y-auto pr-2">
                <li className="flex items-start">
                  <span className="mr-2 text-[#9CA3AF]"></span>
                  <div>
                    <p className="font-medium">Stay tuned for updates.</p>
                    <p className="text-[#6B7280]"></p>
                  </div>
                </li>
                <li>
                  <p className="font-medium"></p>
                  <p className="text-[#6B7280]"></p>
                </li>
                <li>
                  <p className="font-medium"></p>
                  <p className="text-[#6B7280]"></p>
                </li>
                <li>
                  <p className="font-medium"></p>
                  <p className="text-[#6B7280]"></p>
                </li>
                <li>
                  <p className="font-medium"></p>
                  <p className="text-[#6B7280]"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>

      </div>

      {/* Pagination Buttons */}
      <div className="flex justify-center mt-6 space-x-2">
        {totalPages > 1 && (
          <div className="flex justify-center mt-6 space-x-2">
            {/* Prev Button */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 border border-[#D1D5DB] rounded text-sm text-[#4B5563] hover:bg-[#F3F4F6] disabled:opacity-50"
            >
              Prev
            </button>

            {/* Page Numbers */}
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`px-3 py-1 border text-sm rounded ${currentPage === i + 1
                  ? "bg-[#EEF2FF] border-[#A5B4FC] text-[#1F2937]"
                  : "border-[#D1D5DB] text-[#4B5563] hover:bg-[#F3F4F6]"
                  }`}
              >
                {i + 1}
              </button>
            ))}

            {/* Next Button */}
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="px-3 py-1 border border-[#D1D5DB] rounded text-sm text-[#4B5563] hover:bg-[#F3F4F6] disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>

      {showAddModal && <ModalLayout title="Add Flash Alert">
        <div>
          <form className="mt-5" onSubmit={handleFlashAlertSubmit}>
            {/* Title Input */}
            <div className="mb-2">
              <label htmlFor="title" className="mb-1 block text-black dark:text-white text-sm">
                Title
              </label>
              <input
                type="text"
                id="title"
                name="title"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                className="border-gray w-full text-black rounded border-[1.5px] border-stroke bg-transparent py-1 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
              />
            </div>

            {/* Date and Location Inputs side by side */}
            <div className="mb-2 flex space-x-4">
              <div className="flex-1">
                <label htmlFor="date" className="mb-1 block text-black dark:text-white text-sm">
                  Date
                </label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={dateField}
                  onChange={(e) => setDateField(e.target.value)}
                  className="border-gray w-full text-black rounded border-[1.5px] border-stroke bg-transparent py-1 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
                />
              </div>
              <div className="flex-1">
                <label htmlFor="location" className="mb-1 block text-black dark:text-white text-sm">
                  Location
                </label>
                <input
                  type="text"
                  id="location"
                  name="location"
                  placeholder="Region, District"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  className="border-gray w-full text-black rounded border-[1.5px] border-stroke bg-transparent py-1 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
                />
              </div>
            </div>

            {/* Description (Rich Text Editor) */}
            <div className="mb-2">
              <label htmlFor="description" className="mb-1 block text-black dark:text-white text-sm">
                Description
              </label>
              <textarea
                id="description"
                name="description"
                placeholder="Enter description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="border-gray w-full text-black rounded border-[1.5px] border-stroke bg-transparent py-1 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
                style={{ minHeight: '120px' }} // Set the minHeight to increase the size
              />
            </div>

            {/* Images Input */}
            <div className="mb-2">
              <label htmlFor="file" className="mb-1 block text-black dark:text-white text-sm">
                Images
              </label>
              <input
                type="file"
                multiple
                id="images"
                name="images"
                onChange={(e) => setImages(e.target.files)}
                className="border-gray w-full text-black rounded border-stroke bg-transparent py-1 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
              />
            </div>

            {/* Added By Input */}
            <div className="mb-2">
              <label htmlFor="addedBy" className="mb-1 block text-black dark:text-white text-sm">
                Input By
              </label>
              <input
                type="text"
                id="added_by"
                name="added_by"
                placeholder="Your Name"
                value={addedBy}
                onChange={(e) => setAddedBy(e.target.value)}
                className="border-gray w-full text-black rounded border-[1.5px] border-stroke bg-transparent py-1 px-5 font-medium outline-none transition focus:border-primary active:border-primary dark:border-gray dark:bg-form-input dark:focus:border-primary"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-2">
              <button
                type="button"
                className="py-2 px-4 rounded text-white bg-danger"
                onClick={() => setShowAddModal(false)}
              >
                Close
              </button>
              <button type="submit" className="py-2 px-4 rounded text-white bg-primary">
                Submit
              </button>
            </div>
          </form>

        </div>
      </ModalLayout>}
    </div>);
};

export default Index;
